import { fromPairs, map } from 'lodash/fp';
import React, { ReactNode } from 'react';
import { pipe } from 'ts-opt';
import { OtherSubjectRoleManagement } from 'api/gen/OtherSubjectRoleManagement';
import { UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement } from 'api/gen/UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement';
import { DynamicContent } from './gen-dynamic-content';
import { ManagementOtherSubjectsTableType } from '../../types/management-other-subjects';
import { getExpirationColor } from '../../utils/get-expiration-color';
const genDynamicColumns = (roles: Array<OtherSubjectRoleManagement>, onCellClick: (userProfileOtherSubjectRoleId: number) => void): Record<string, ReactNode> => pipe(roles, map(role => [role.roleId.toString(), <span key={role.roleId} className={getExpirationColor(role.bindingExpiration)}>
            <DynamicContent key={role.roleId} onCellClick={onCellClick} userProfileOtherSubjectRoleId={role.userProfileOtherSubjectRoleId} />
        </span>]), fromPairs);

/**
 * Maps other-subject-management API rows into the tree-table representation.
 *
 * @param row Source API row with other-subject access data and role bindings.
 * @param onCellClick Callback invoked when a role cell is activated.
 * @returns The other-subject-management table row.
 *
 * @example
 * managementOtherSubjectsRowMapper(row, handleRoleClick);
 */
export const managementOtherSubjectsRowMapper = (row: UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement, onCellClick: (userProfileOtherSubjectRoleId: number) => void): ManagementOtherSubjectsTableType => ({
  id: row.userProfileId,
  username: row.username,
  userProfileId: row.userProfileId,
  roles: row.roles,
  isSubjectMember: row.isSubjectMember,
  ...genDynamicColumns(row.roles, onCellClick)
});